webpackJsonp([17],{

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(220)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(247),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51ec59da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Podcast',
  metaInfo: {
    title: 'Crypto Podcast Progressbar | PPPP'
  },
  data: function data() {
    return {
      href: {
        coworkGroup: 'https://t.me/coworkprogressbar',
        googleMapsProgressbar: 'https://goo.gl/maps/5Vgh7SUAL6N2',
        coworkerProgressbar: 'https://www.coworker.com/slovakia/bratislava/cowork-progressbar',
        facebookPageProgressbar: 'https://www.facebook.com/pg/progressbar/reviews/',
        instagram: 'https://www.instagram.com/progressbar_sk/'
      }
    };
  }
});

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(99)(true);
// imports


// module
exports.push([module.i, "@media only screen and (max-width:768px){iframe[data-v-51ec59da]{width:85vw}}iframe[data-v-51ec59da]{width:100%}a[data-v-51ec59da]{color:hotpink}", "", {"version":3,"sources":["/opt/build/repo/cowork-panel/src/components/Podcast.vue"],"names":[],"mappings":"AACA,yCACA,wBACM,UAAY,CACjB,CACA,AACD,wBACI,UAAY,CACf,AACD,mBACE,aAAe,CAChB","file":"Podcast.vue","sourcesContent":["\n@media only screen and (max-width: 768px) {\niframe[data-v-51ec59da] {\n      width: 85vw;\n}\n}\niframe[data-v-51ec59da] {\n    width: 100%;\n}\na[data-v-51ec59da] {\n  color: hotpink;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(196);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(100)("1e3b2ecd", content, true, {});

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Podcast"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-12 content"
  }, [_c('h1', {}, [_c('a', {
    attrs: {
      "href": "https://cowork.progressbar.sk/podcast"
    }
  }, [_vm._v("Prvý Pokusný Podcast Progressbaru - PPPP - ⛓ links")]), _c('br'), _c('br'), _vm._v("\n      💬 "), _c('a', {
    attrs: {
      "href": "https://t.me/progressbarpodcast"
    }
  }, [_vm._v("Telegram Channel")]), _c('br'), _vm._v("\n      🎥 "), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/playlist?list=PLfCtn83lMV3CzkXkGdkdUnNZvD5c4hBbC"
    }
  }, [_vm._v("Youtube Playlist")]), _c('br'), _vm._v("\n      🎧 "), _c('a', {
    attrs: {
      "href": "https://podcasts.apple.com/us/podcast/id1465903607"
    }
  }, [_vm._v("Apple Podcasts")]), _c('br'), _vm._v("\n      🎧 "), _c('a', {
    attrs: {
      "href": "https://open.spotify.com/show/2arFgMfH8p27iEpwJmFv23"
    }
  }, [_vm._v("Spotify")]), _c('br'), _vm._v("\n      🐬 "), _c('a', {
    attrs: {
      "href": "https://api.substack.com/feed/podcast/10023.rss"
    }
  }, [_vm._v("RSS")]), _c('br'), _vm._v("\n      📧 "), _c('a', {
    attrs: {
      "href": "https://pppp.substack.com/"
    }
  }, [_vm._v("Newsletter")]), _c('br'), _vm._v("\n      🤑 "), _c('router-link', {
    attrs: {
      "to": "/pay"
    }
  }, [_vm._v("Support us")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column is-12 content"
  }, [_c('iframe', {
    attrs: {
      "height": "600",
      "src": "https://www.youtube.com/embed/videoseries?list=PLfCtn83lMV3CzkXkGdkdUnNZvD5c4hBbC",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/17.4c6531e2a886e7031b3d.js